import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { useDeviceType } from '../../../responsive';
import { useControlledValue } from '../../internal';
import { SelectMobile } from '../SelectMobile';
import { SelectDesktop } from '../SelectDesktop';

/**
 * Адаптивный select-компонент для выбора одного значения из списка
 *
 * * Десктопный вариант открывает выпадающий список
 * * Мобильный вариант открывает список в модальном окне
 */
export var Select = /*#__PURE__*/React.forwardRef(function Select(props, ref) {
  var deviceType = useDeviceType();
  var _useControlledValue = useControlledValue(props, null),
    value = _useControlledValue.value,
    onChange = _useControlledValue.onChange;
  if (deviceType === 'phone') {
    return /*#__PURE__*/React.createElement(SelectMobile, _extends({}, props, {
      ref: ref,
      value: value,
      onChange: onChange
    }));
  }
  return /*#__PURE__*/React.createElement(SelectDesktop, _extends({}, props, {
    ref: ref,
    value: value,
    onChange: onChange
  }));
});